export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.AmbiguousColumnReference';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.CannotCastValueOfType';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.DatabaseNotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.InvalidIdentifier';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.InvalidParameterTypeForFunction';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_MISSING_COLUMN =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.MissingColumn';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.NotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.SchemaNotExistsOrNotAuthorized';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.UncategorizedSqlError';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.UnknownFunction';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.UnknownFunctions';
export const CREATE_SNOWFLAKE_SYSTEM_WITH_SANDBOX_USER_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.CreateSnowflakeSystemWithSandboxUser.ValueNotRecognized';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.DeleteSnowflakeTable.AmbiguousColumnReference';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.DeleteSnowflakeTable.CannotCastValueOfType';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.DeleteSnowflakeTable.ClientConnectionError';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.DeleteSnowflakeTable.DataLoadingFailed';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.DeleteSnowflakeTable.DatabaseNotExistsOrNotAuthorized';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.DeleteSnowflakeTable.InsufficientPrivileges';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.DeleteSnowflakeTable.InsufficientTaskPrivileges';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.DeleteSnowflakeTable.InvalidAccessToken';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.DeleteSnowflakeTable.InvalidAccountName';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.DeleteSnowflakeTable.InvalidIdentifier';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.DeleteSnowflakeTable.InvalidParameterTypeForFunction';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.DeleteSnowflakeTable.MaxFileSizeExceeded';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_MISSING_COLUMN =
    'europa.snowflake.DeleteSnowflakeTable.MissingColumn';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.DeleteSnowflakeTable.NoActiveWarehouseSelected';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.DeleteSnowflakeTable.NotAuthenticatedToSnowflake';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.DeleteSnowflakeTable.NotExistsOrNotAuthorized';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.DeleteSnowflakeTable.NotExistsOrOperationCannotBePerformed';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.DeleteSnowflakeTable.ObjectAlreadyExists';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.DeleteSnowflakeTable.SchemaNotExistsOrNotAuthorized';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.DeleteSnowflakeTable.SnowflakeInternalServerError';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.DeleteSnowflakeTable.SnowflakeNotConfigured';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.DeleteSnowflakeTable.SnowflakeQueryCanceled';
export const DELETE_SNOWFLAKE_TABLE_SUCCESS_SNOWFLAKE_TABLE_DELETED =
    'europa.snowflake.DeleteSnowflakeTable.SnowflakeTableDeleted';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_TIMEOUT =
    'europa.snowflake.DeleteSnowflakeTable.Timeout';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.DeleteSnowflakeTable.UncategorizedSqlError';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.DeleteSnowflakeTable.UnexpectedFailure';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.DeleteSnowflakeTable.UnknownFunction';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.DeleteSnowflakeTable.UnknownFunctions';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.DeleteSnowflakeTable.UserDiffersFromToken';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.DeleteSnowflakeTable.ValueNotRecognized';
export const DELETE_SNOWFLAKE_TABLE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.DeleteSnowflakeTable.WarehouseSuspended';
export const DELETE_SNOWFLAKE_USER_CREDENTIALS_SUCCESS_SUCCEEDED =
    'europa.snowflake.DeleteSnowflakeUserCredentials.Succeeded';
export const DELETE_SNOWFLAKE_USER_CREDENTIALS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.DeleteSnowflakeUserCredentials.UnexpectedFailure';
export const EXECUTE_ARBITRARY_SQL_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.ExecuteArbitrarySql.AmbiguousColumnReference';
export const EXECUTE_ARBITRARY_SQL_SUCCESS_ARBITRARY_SQL_RESULT =
    'europa.snowflake.ExecuteArbitrarySql.ArbitrarySqlResult';
export const EXECUTE_ARBITRARY_SQL_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.ExecuteArbitrarySql.CannotCastValueOfType';
export const EXECUTE_ARBITRARY_SQL_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.ExecuteArbitrarySql.ClientConnectionError';
export const EXECUTE_ARBITRARY_SQL_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.ExecuteArbitrarySql.DataLoadingFailed';
export const EXECUTE_ARBITRARY_SQL_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ExecuteArbitrarySql.DatabaseNotExistsOrNotAuthorized';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.ExecuteArbitrarySql.InsufficientPrivileges';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.ExecuteArbitrarySql.InsufficientTaskPrivileges';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.ExecuteArbitrarySql.InvalidAccessToken';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.ExecuteArbitrarySql.InvalidAccountName';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.ExecuteArbitrarySql.InvalidIdentifier';
export const EXECUTE_ARBITRARY_SQL_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.ExecuteArbitrarySql.InvalidParameterTypeForFunction';
export const EXECUTE_ARBITRARY_SQL_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.ExecuteArbitrarySql.MaxFileSizeExceeded';
export const EXECUTE_ARBITRARY_SQL_FAILURE_MISSING_COLUMN =
    'europa.snowflake.ExecuteArbitrarySql.MissingColumn';
export const EXECUTE_ARBITRARY_SQL_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.ExecuteArbitrarySql.NoActiveWarehouseSelected';
export const EXECUTE_ARBITRARY_SQL_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.ExecuteArbitrarySql.NotAuthenticatedToSnowflake';
export const EXECUTE_ARBITRARY_SQL_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ExecuteArbitrarySql.NotExistsOrNotAuthorized';
export const EXECUTE_ARBITRARY_SQL_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.ExecuteArbitrarySql.NotExistsOrOperationCannotBePerformed';
export const EXECUTE_ARBITRARY_SQL_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.ExecuteArbitrarySql.ObjectAlreadyExists';
export const EXECUTE_ARBITRARY_SQL_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ExecuteArbitrarySql.SchemaNotExistsOrNotAuthorized';
export const EXECUTE_ARBITRARY_SQL_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.ExecuteArbitrarySql.SnowflakeInternalServerError';
export const EXECUTE_ARBITRARY_SQL_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.ExecuteArbitrarySql.SnowflakeNotConfigured';
export const EXECUTE_ARBITRARY_SQL_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.ExecuteArbitrarySql.SnowflakeQueryCanceled';
export const EXECUTE_ARBITRARY_SQL_FAILURE_TIMEOUT = 'europa.snowflake.ExecuteArbitrarySql.Timeout';
export const EXECUTE_ARBITRARY_SQL_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.ExecuteArbitrarySql.UncategorizedSqlError';
export const EXECUTE_ARBITRARY_SQL_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.ExecuteArbitrarySql.UnexpectedFailure';
export const EXECUTE_ARBITRARY_SQL_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.ExecuteArbitrarySql.UnknownFunction';
export const EXECUTE_ARBITRARY_SQL_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.ExecuteArbitrarySql.UnknownFunctions';
export const EXECUTE_ARBITRARY_SQL_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.ExecuteArbitrarySql.UserDiffersFromToken';
export const EXECUTE_ARBITRARY_SQL_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.ExecuteArbitrarySql.ValueNotRecognized';
export const EXECUTE_ARBITRARY_SQL_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.ExecuteArbitrarySql.WarehouseSuspended';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.FetchSnowflakeTableColumns.AmbiguousColumnReference';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.FetchSnowflakeTableColumns.CannotCastValueOfType';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.FetchSnowflakeTableColumns.ClientConnectionError';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.FetchSnowflakeTableColumns.DataLoadingFailed';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.FetchSnowflakeTableColumns.DatabaseNotExistsOrNotAuthorized';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.FetchSnowflakeTableColumns.InsufficientPrivileges';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.FetchSnowflakeTableColumns.InsufficientTaskPrivileges';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.FetchSnowflakeTableColumns.InvalidAccessToken';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.FetchSnowflakeTableColumns.InvalidAccountName';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.FetchSnowflakeTableColumns.InvalidIdentifier';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.FetchSnowflakeTableColumns.InvalidParameterTypeForFunction';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.FetchSnowflakeTableColumns.MaxFileSizeExceeded';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_MISSING_COLUMN =
    'europa.snowflake.FetchSnowflakeTableColumns.MissingColumn';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.FetchSnowflakeTableColumns.NoActiveWarehouseSelected';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.FetchSnowflakeTableColumns.NotAuthenticatedToSnowflake';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.FetchSnowflakeTableColumns.NotExistsOrNotAuthorized';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.FetchSnowflakeTableColumns.NotExistsOrOperationCannotBePerformed';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.FetchSnowflakeTableColumns.ObjectAlreadyExists';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.FetchSnowflakeTableColumns.SchemaNotExistsOrNotAuthorized';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.FetchSnowflakeTableColumns.SnowflakeInternalServerError';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.FetchSnowflakeTableColumns.SnowflakeNotConfigured';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.FetchSnowflakeTableColumns.SnowflakeQueryCanceled';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_SUCCESS_SNOWFLAKE_TABLE_COLUMNS =
    'europa.snowflake.FetchSnowflakeTableColumns.SnowflakeTableColumns';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_TIMEOUT =
    'europa.snowflake.FetchSnowflakeTableColumns.Timeout';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.FetchSnowflakeTableColumns.UncategorizedSqlError';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.FetchSnowflakeTableColumns.UnexpectedFailure';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.FetchSnowflakeTableColumns.UnknownFunction';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.FetchSnowflakeTableColumns.UnknownFunctions';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.FetchSnowflakeTableColumns.UserDiffersFromToken';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.FetchSnowflakeTableColumns.ValueNotRecognized';
export const FETCH_SNOWFLAKE_TABLE_COLUMNS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.FetchSnowflakeTableColumns.WarehouseSuspended';
export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE_SUCCESS_DATAMEER_DEFINED =
    'europa.snowflake.GetDatameerSnowflakeWarehouse.DatameerDefined';
export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE_SUCCESS_NOT_YET_CONFIGURED =
    'europa.snowflake.GetDatameerSnowflakeWarehouse.NotYetConfigured';
export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE_SUCCESS_SNOWFLAKE_DEFAULT_DEFINED =
    'europa.snowflake.GetDatameerSnowflakeWarehouse.SnowflakeDefaultDefined';
export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.GetDatameerSnowflakeWarehouse.SnowflakeNotConfigured';
export const GET_DATAMEER_SNOWFLAKE_WAREHOUSE_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.GetDatameerSnowflakeWarehouse.UnexpectedFailure';
export const GET_SNOWFLAKE_AUTHORIZATION_URL_FAILURE_CONNECTION_NOT_CONFIGURED =
    'europa.snowflake.GetSnowflakeAuthorizationUrl.ConnectionNotConfigured';
export const GET_SNOWFLAKE_AUTHORIZATION_URL_FAILURE_DISCOVERY_FAILURE =
    'europa.snowflake.GetSnowflakeAuthorizationUrl.DiscoveryFailure';
export const GET_SNOWFLAKE_AUTHORIZATION_URL_FAILURE_SECRET_NOT_FOUND =
    'europa.snowflake.GetSnowflakeAuthorizationUrl.SecretNotFound';
export const GET_SNOWFLAKE_AUTHORIZATION_URL_SUCCESS_SNOWFLAKE_AUTHORIZATION_URL =
    'europa.snowflake.GetSnowflakeAuthorizationUrl.SnowflakeAuthorizationUrl';
export const GET_SNOWFLAKE_AUTHORIZATION_URL_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.GetSnowflakeAuthorizationUrl.UnexpectedFailure';
export const GET_SNOWFLAKE_CONFIGURATION_FAILURE_CONNECTION_NOT_CONFIGURED =
    'europa.snowflake.GetSnowflakeConfiguration.ConnectionNotConfigured';
export const GET_SNOWFLAKE_CONFIGURATION_FAILURE_SECRET_NOT_FOUND =
    'europa.snowflake.GetSnowflakeConfiguration.SecretNotFound';
export const GET_SNOWFLAKE_CONFIGURATION_SUCCESS_SNOWFLAKE_CONNECTION =
    'europa.snowflake.GetSnowflakeConfiguration.SnowflakeConnection';
export const GET_SNOWFLAKE_CONFIGURATION_SUCCESS_SNOWFLAKE_MULTI_USER_CONFIGURATION =
    'europa.snowflake.GetSnowflakeConfiguration.SnowflakeMultiUserConfiguration';
export const GET_SNOWFLAKE_CONFIGURATION_SUCCESS_SNOWFLAKE_O_AUTH_2_CONNECTION =
    'europa.snowflake.GetSnowflakeConfiguration.SnowflakeOAuth2Connection';
export const GET_SNOWFLAKE_CONFIGURATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.GetSnowflakeConfiguration.UnexpectedFailure';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.GetSnowflakeConnectionDetails.AmbiguousColumnReference';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_CANCELED =
    'europa.snowflake.GetSnowflakeConnectionDetails.Canceled';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.GetSnowflakeConnectionDetails.CannotCastValueOfType';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.GetSnowflakeConnectionDetails.ClientConnectionError';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.GetSnowflakeConnectionDetails.DataLoadingFailed';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.GetSnowflakeConnectionDetails.DatabaseNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.GetSnowflakeConnectionDetails.InsufficientPrivileges';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.GetSnowflakeConnectionDetails.InsufficientTaskPrivileges';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.GetSnowflakeConnectionDetails.InvalidAccessToken';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.GetSnowflakeConnectionDetails.InvalidAccountName';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.GetSnowflakeConnectionDetails.InvalidIdentifier';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.GetSnowflakeConnectionDetails.InvalidParameterTypeForFunction';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.GetSnowflakeConnectionDetails.MaxFileSizeExceeded';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_MISSING_COLUMN =
    'europa.snowflake.GetSnowflakeConnectionDetails.MissingColumn';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.GetSnowflakeConnectionDetails.NoActiveWarehouseSelected';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.GetSnowflakeConnectionDetails.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.GetSnowflakeConnectionDetails.NotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.GetSnowflakeConnectionDetails.NotExistsOrOperationCannotBePerformed';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.GetSnowflakeConnectionDetails.ObjectAlreadyExists';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.GetSnowflakeConnectionDetails.SchemaNotExistsOrNotAuthorized';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_SUCCESS_SNOWFLAKE_CONNECTION_DETAILS =
    'europa.snowflake.GetSnowflakeConnectionDetails.SnowflakeConnectionDetails';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.GetSnowflakeConnectionDetails.SnowflakeInternalServerError';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.GetSnowflakeConnectionDetails.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.GetSnowflakeConnectionDetails.SnowflakeQueryCanceled';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_TIMEOUT =
    'europa.snowflake.GetSnowflakeConnectionDetails.Timeout';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.GetSnowflakeConnectionDetails.UncategorizedSqlError';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.GetSnowflakeConnectionDetails.UnexpectedFailure';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.GetSnowflakeConnectionDetails.UnknownFunction';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.GetSnowflakeConnectionDetails.UnknownFunctions';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.GetSnowflakeConnectionDetails.UserDiffersFromToken';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.GetSnowflakeConnectionDetails.ValueNotRecognized';
export const GET_SNOWFLAKE_CONNECTION_DETAILS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.GetSnowflakeConnectionDetails.WarehouseSuspended';
export const GET_SNOWFLAKE_TABLE_CONNECTION_DETAILS_SUCCESS_CONNECTION_DETAILS =
    'europa.snowflake.GetSnowflakeTableConnectionDetails.ConnectionDetails';
export const GET_SNOWFLAKE_TABLE_CONNECTION_DETAILS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.GetSnowflakeTableConnectionDetails.NotAuthenticatedToSnowflake';
export const GET_SNOWFLAKE_TABLE_CONNECTION_DETAILS_FAILURE_SECRET_NOT_FOUND =
    'europa.snowflake.GetSnowflakeTableConnectionDetails.SecretNotFound';
export const GET_SNOWFLAKE_TABLE_CONNECTION_DETAILS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.GetSnowflakeTableConnectionDetails.SnowflakeNotConfigured';
export const GET_SNOWFLAKE_TABLE_CONNECTION_DETAILS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.GetSnowflakeTableConnectionDetails.UnexpectedFailure';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.ListRolesAndWarehouses.AmbiguousColumnReference';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.ListRolesAndWarehouses.CannotCastValueOfType';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.ListRolesAndWarehouses.ClientConnectionError';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.ListRolesAndWarehouses.DataLoadingFailed';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListRolesAndWarehouses.DatabaseNotExistsOrNotAuthorized';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.ListRolesAndWarehouses.InsufficientPrivileges';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.ListRolesAndWarehouses.InsufficientTaskPrivileges';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.ListRolesAndWarehouses.InvalidAccessToken';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.ListRolesAndWarehouses.InvalidAccountName';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.ListRolesAndWarehouses.InvalidIdentifier';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.ListRolesAndWarehouses.InvalidParameterTypeForFunction';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.ListRolesAndWarehouses.MaxFileSizeExceeded';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_MISSING_COLUMN =
    'europa.snowflake.ListRolesAndWarehouses.MissingColumn';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.ListRolesAndWarehouses.NoActiveWarehouseSelected';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.ListRolesAndWarehouses.NotAuthenticatedToSnowflake';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListRolesAndWarehouses.NotExistsOrNotAuthorized';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.ListRolesAndWarehouses.NotExistsOrOperationCannotBePerformed';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.ListRolesAndWarehouses.ObjectAlreadyExists';
export const LIST_ROLES_AND_WAREHOUSES_SUCCESS_ROLES_AND_WAREHOUSES =
    'europa.snowflake.ListRolesAndWarehouses.RolesAndWarehouses';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListRolesAndWarehouses.SchemaNotExistsOrNotAuthorized';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_SECRET_NOT_FOUND =
    'europa.snowflake.ListRolesAndWarehouses.SecretNotFound';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.ListRolesAndWarehouses.SnowflakeInternalServerError';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.ListRolesAndWarehouses.SnowflakeNotConfigured';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.ListRolesAndWarehouses.SnowflakeQueryCanceled';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_TIMEOUT =
    'europa.snowflake.ListRolesAndWarehouses.Timeout';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.ListRolesAndWarehouses.UncategorizedSqlError';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.ListRolesAndWarehouses.UnexpectedFailure';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.ListRolesAndWarehouses.UnknownFunction';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.ListRolesAndWarehouses.UnknownFunctions';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.ListRolesAndWarehouses.UserDiffersFromToken';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.ListRolesAndWarehouses.ValueNotRecognized';
export const LIST_ROLES_AND_WAREHOUSES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.ListRolesAndWarehouses.WarehouseSuspended';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.ListSnowflakeWarehouses.AmbiguousColumnReference';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.ListSnowflakeWarehouses.CannotCastValueOfType';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.ListSnowflakeWarehouses.ClientConnectionError';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.ListSnowflakeWarehouses.DataLoadingFailed';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListSnowflakeWarehouses.DatabaseNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.ListSnowflakeWarehouses.InsufficientPrivileges';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.ListSnowflakeWarehouses.InsufficientTaskPrivileges';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.ListSnowflakeWarehouses.InvalidAccessToken';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.ListSnowflakeWarehouses.InvalidAccountName';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.ListSnowflakeWarehouses.InvalidIdentifier';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.ListSnowflakeWarehouses.InvalidParameterTypeForFunction';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.ListSnowflakeWarehouses.MaxFileSizeExceeded';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_MISSING_COLUMN =
    'europa.snowflake.ListSnowflakeWarehouses.MissingColumn';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.ListSnowflakeWarehouses.NoActiveWarehouseSelected';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.ListSnowflakeWarehouses.NotAuthenticatedToSnowflake';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListSnowflakeWarehouses.NotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.ListSnowflakeWarehouses.NotExistsOrOperationCannotBePerformed';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.ListSnowflakeWarehouses.ObjectAlreadyExists';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.ListSnowflakeWarehouses.SchemaNotExistsOrNotAuthorized';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.ListSnowflakeWarehouses.SnowflakeInternalServerError';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.ListSnowflakeWarehouses.SnowflakeNotConfigured';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.ListSnowflakeWarehouses.SnowflakeQueryCanceled';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_TIMEOUT =
    'europa.snowflake.ListSnowflakeWarehouses.Timeout';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.ListSnowflakeWarehouses.UncategorizedSqlError';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.ListSnowflakeWarehouses.UnexpectedFailure';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.ListSnowflakeWarehouses.UnknownFunction';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.ListSnowflakeWarehouses.UnknownFunctions';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.ListSnowflakeWarehouses.UserDiffersFromToken';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.ListSnowflakeWarehouses.ValueNotRecognized';
export const LIST_SNOWFLAKE_WAREHOUSES_SUCCESS_WAREHOUSE_LIST =
    'europa.snowflake.ListSnowflakeWarehouses.WarehouseList';
export const LIST_SNOWFLAKE_WAREHOUSES_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.ListSnowflakeWarehouses.WarehouseSuspended';
export const REVOKE_SNOWFLAKE_TOKEN_SUCCESS_SUCCEEDED =
    'europa.snowflake.RevokeSnowflakeToken.Succeeded';
export const REVOKE_SNOWFLAKE_TOKEN_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.RevokeSnowflakeToken.UnexpectedFailure';
export const SET_DATAMEER_SNOWFLAKE_WAREHOUSE_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetDatameerSnowflakeWarehouse.UnexpectedFailure';
export const SET_DATAMEER_SNOWFLAKE_WAREHOUSE_SUCCESS_WAREHOUSE_CHANGED =
    'europa.snowflake.SetDatameerSnowflakeWarehouse.WarehouseChanged';
export const SET_SNOWFLAKE_MULTI_USER_CONFIGURATION_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.snowflake.SetSnowflakeMultiUserConfiguration.OperationNotPermitted';
export const SET_SNOWFLAKE_MULTI_USER_CONFIGURATION_FAILURE_SNOWFLAKE_ACCOUNT_NOT_EXISTS_OR_NOT_ACCESSIBLE =
    'europa.snowflake.SetSnowflakeMultiUserConfiguration.SnowflakeAccountNotExistsOrNotAccessible';
export const SET_SNOWFLAKE_MULTI_USER_CONFIGURATION_SUCCESS_SNOWFLAKE_CONFIGURATION_SET =
    'europa.snowflake.SetSnowflakeMultiUserConfiguration.SnowflakeConfigurationSet';
export const SET_SNOWFLAKE_MULTI_USER_CONFIGURATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeMultiUserConfiguration.UnexpectedFailure';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_ADVANCED_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionAdvanced.OperationNotPermitted';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_ADVANCED_SUCCESS_SNOWFLAKE_CONFIGURATION_SET =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionAdvanced.SnowflakeConfigurationSet';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_ADVANCED_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionAdvanced.UnexpectedFailure';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_DISCOVERY_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionDiscovery.OperationNotPermitted';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_DISCOVERY_SUCCESS_SNOWFLAKE_CONFIGURATION_SET =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionDiscovery.SnowflakeConfigurationSet';
export const SET_SNOWFLAKE_O_AUTH_2_CONNECTION_DISCOVERY_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeOAuth2ConnectionDiscovery.UnexpectedFailure';
export const SET_SNOWFLAKE_ROLE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.SetSnowflakeRole.AmbiguousColumnReference';
export const SET_SNOWFLAKE_ROLE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.SetSnowflakeRole.CannotCastValueOfType';
export const SET_SNOWFLAKE_ROLE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.SetSnowflakeRole.ClientConnectionError';
export const SET_SNOWFLAKE_ROLE_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.SetSnowflakeRole.DataLoadingFailed';
export const SET_SNOWFLAKE_ROLE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeRole.DatabaseNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_ROLE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.SetSnowflakeRole.InsufficientPrivileges';
export const SET_SNOWFLAKE_ROLE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.SetSnowflakeRole.InsufficientTaskPrivileges';
export const SET_SNOWFLAKE_ROLE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.SetSnowflakeRole.InvalidAccessToken';
export const SET_SNOWFLAKE_ROLE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.SetSnowflakeRole.InvalidAccountName';
export const SET_SNOWFLAKE_ROLE_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.SetSnowflakeRole.InvalidIdentifier';
export const SET_SNOWFLAKE_ROLE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.SetSnowflakeRole.InvalidParameterTypeForFunction';
export const SET_SNOWFLAKE_ROLE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.SetSnowflakeRole.MaxFileSizeExceeded';
export const SET_SNOWFLAKE_ROLE_FAILURE_MISSING_COLUMN =
    'europa.snowflake.SetSnowflakeRole.MissingColumn';
export const SET_SNOWFLAKE_ROLE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.SetSnowflakeRole.NoActiveWarehouseSelected';
export const SET_SNOWFLAKE_ROLE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.SetSnowflakeRole.NotAuthenticatedToSnowflake';
export const SET_SNOWFLAKE_ROLE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeRole.NotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_ROLE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.SetSnowflakeRole.NotExistsOrOperationCannotBePerformed';
export const SET_SNOWFLAKE_ROLE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.SetSnowflakeRole.ObjectAlreadyExists';
export const SET_SNOWFLAKE_ROLE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeRole.SchemaNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_ROLE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.SetSnowflakeRole.SnowflakeInternalServerError';
export const SET_SNOWFLAKE_ROLE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.SetSnowflakeRole.SnowflakeNotConfigured';
export const SET_SNOWFLAKE_ROLE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.SetSnowflakeRole.SnowflakeQueryCanceled';
export const SET_SNOWFLAKE_ROLE_SUCCESS_SUCCEEDED = 'europa.snowflake.SetSnowflakeRole.Succeeded';
export const SET_SNOWFLAKE_ROLE_FAILURE_TIMEOUT = 'europa.snowflake.SetSnowflakeRole.Timeout';
export const SET_SNOWFLAKE_ROLE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.SetSnowflakeRole.UncategorizedSqlError';
export const SET_SNOWFLAKE_ROLE_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeRole.UnexpectedFailure';
export const SET_SNOWFLAKE_ROLE_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.SetSnowflakeRole.UnknownFunction';
export const SET_SNOWFLAKE_ROLE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.SetSnowflakeRole.UnknownFunctions';
export const SET_SNOWFLAKE_ROLE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.SetSnowflakeRole.UserDiffersFromToken';
export const SET_SNOWFLAKE_ROLE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.SetSnowflakeRole.ValueNotRecognized';
export const SET_SNOWFLAKE_ROLE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.SetSnowflakeRole.WarehouseSuspended';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.AmbiguousColumnReference';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.CannotCastValueOfType';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.ClientConnectionError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.DataLoadingFailed';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.DatabaseNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InsufficientPrivileges';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InsufficientTaskPrivileges';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InvalidAccessToken';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InvalidAccountName';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InvalidIdentifier';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.InvalidParameterTypeForFunction';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.MaxFileSizeExceeded';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_MISSING_COLUMN =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.MissingColumn';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.NoActiveWarehouseSelected';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.NotAuthenticatedToSnowflake';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.NotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.NotExistsOrOperationCannotBePerformed';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.ObjectAlreadyExists';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.OperationNotPermitted';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.SchemaNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_SUCCESS_SNOWFLAKE_CONFIGURATION_SET =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.SnowflakeConfigurationSet';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.SnowflakeInternalServerError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.SnowflakeNotConfigured';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.SnowflakeQueryCanceled';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_TIMEOUT =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.Timeout';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.UncategorizedSqlError';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.UnexpectedFailure';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.UnknownFunction';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.UnknownFunctions';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.UserDiffersFromToken';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.ValueNotRecognized';
export const SET_SNOWFLAKE_SERVICE_ACCOUNT_CONFIGURATION_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.SetSnowflakeServiceAccountConfiguration.WarehouseSuspended';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.SetSnowflakeUserCredentials.AmbiguousColumnReference';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.SetSnowflakeUserCredentials.CannotCastValueOfType';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.SetSnowflakeUserCredentials.ClientConnectionError';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.SetSnowflakeUserCredentials.DataLoadingFailed';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeUserCredentials.DatabaseNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.SetSnowflakeUserCredentials.InsufficientPrivileges';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.SetSnowflakeUserCredentials.InsufficientTaskPrivileges';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.SetSnowflakeUserCredentials.InvalidAccessToken';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.SetSnowflakeUserCredentials.InvalidAccountName';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.SetSnowflakeUserCredentials.InvalidIdentifier';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.SetSnowflakeUserCredentials.InvalidParameterTypeForFunction';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.SetSnowflakeUserCredentials.MaxFileSizeExceeded';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_MISSING_COLUMN =
    'europa.snowflake.SetSnowflakeUserCredentials.MissingColumn';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.SetSnowflakeUserCredentials.NoActiveWarehouseSelected';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.SetSnowflakeUserCredentials.NotAuthenticatedToSnowflake';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeUserCredentials.NotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.SetSnowflakeUserCredentials.NotExistsOrOperationCannotBePerformed';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.SetSnowflakeUserCredentials.ObjectAlreadyExists';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_OPERATION_NOT_PERMITTED =
    'europa.snowflake.SetSnowflakeUserCredentials.OperationNotPermitted';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeUserCredentials.SchemaNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.SetSnowflakeUserCredentials.SnowflakeInternalServerError';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.SetSnowflakeUserCredentials.SnowflakeNotConfigured';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.SetSnowflakeUserCredentials.SnowflakeQueryCanceled';
export const SET_SNOWFLAKE_USER_CREDENTIALS_SUCCESS_SUCCEEDED =
    'europa.snowflake.SetSnowflakeUserCredentials.Succeeded';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_TIMEOUT =
    'europa.snowflake.SetSnowflakeUserCredentials.Timeout';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.SetSnowflakeUserCredentials.UncategorizedSqlError';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeUserCredentials.UnexpectedFailure';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.SetSnowflakeUserCredentials.UnknownFunction';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.SetSnowflakeUserCredentials.UnknownFunctions';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.SetSnowflakeUserCredentials.UserDiffersFromToken';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.SetSnowflakeUserCredentials.ValueNotRecognized';
export const SET_SNOWFLAKE_USER_CREDENTIALS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.SetSnowflakeUserCredentials.WarehouseSuspended';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.SetSnowflakeWarehouse.AmbiguousColumnReference';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.SetSnowflakeWarehouse.CannotCastValueOfType';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.SetSnowflakeWarehouse.ClientConnectionError';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.SetSnowflakeWarehouse.DataLoadingFailed';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeWarehouse.DatabaseNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.SetSnowflakeWarehouse.InsufficientPrivileges';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.SetSnowflakeWarehouse.InsufficientTaskPrivileges';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.SetSnowflakeWarehouse.InvalidAccessToken';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.SetSnowflakeWarehouse.InvalidAccountName';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.SetSnowflakeWarehouse.InvalidIdentifier';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.SetSnowflakeWarehouse.InvalidParameterTypeForFunction';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.SetSnowflakeWarehouse.MaxFileSizeExceeded';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_MISSING_COLUMN =
    'europa.snowflake.SetSnowflakeWarehouse.MissingColumn';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.SetSnowflakeWarehouse.NoActiveWarehouseSelected';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.SetSnowflakeWarehouse.NotAuthenticatedToSnowflake';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeWarehouse.NotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.SetSnowflakeWarehouse.NotExistsOrOperationCannotBePerformed';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.SetSnowflakeWarehouse.ObjectAlreadyExists';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SetSnowflakeWarehouse.SchemaNotExistsOrNotAuthorized';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.SetSnowflakeWarehouse.SnowflakeInternalServerError';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.SetSnowflakeWarehouse.SnowflakeNotConfigured';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.SetSnowflakeWarehouse.SnowflakeQueryCanceled';
export const SET_SNOWFLAKE_WAREHOUSE_SUCCESS_SUCCEEDED =
    'europa.snowflake.SetSnowflakeWarehouse.Succeeded';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_TIMEOUT =
    'europa.snowflake.SetSnowflakeWarehouse.Timeout';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.SetSnowflakeWarehouse.UncategorizedSqlError';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SetSnowflakeWarehouse.UnexpectedFailure';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.SetSnowflakeWarehouse.UnknownFunction';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.SetSnowflakeWarehouse.UnknownFunctions';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.SetSnowflakeWarehouse.UserDiffersFromToken';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.SetSnowflakeWarehouse.ValueNotRecognized';
export const SET_SNOWFLAKE_WAREHOUSE_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.SetSnowflakeWarehouse.WarehouseSuspended';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_AMBIGUOUS_COLUMN_REFERENCE =
    'europa.snowflake.SnowflakeTableExists.AmbiguousColumnReference';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_CANNOT_CAST_VALUE_OF_TYPE =
    'europa.snowflake.SnowflakeTableExists.CannotCastValueOfType';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_CLIENT_CONNECTION_ERROR =
    'europa.snowflake.SnowflakeTableExists.ClientConnectionError';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_DATA_LOADING_FAILED =
    'europa.snowflake.SnowflakeTableExists.DataLoadingFailed';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_DATABASE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SnowflakeTableExists.DatabaseNotExistsOrNotAuthorized';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INSUFFICIENT_PRIVILEGES =
    'europa.snowflake.SnowflakeTableExists.InsufficientPrivileges';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INSUFFICIENT_TASK_PRIVILEGES =
    'europa.snowflake.SnowflakeTableExists.InsufficientTaskPrivileges';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INVALID_ACCESS_TOKEN =
    'europa.snowflake.SnowflakeTableExists.InvalidAccessToken';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INVALID_ACCOUNT_NAME =
    'europa.snowflake.SnowflakeTableExists.InvalidAccountName';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INVALID_IDENTIFIER =
    'europa.snowflake.SnowflakeTableExists.InvalidIdentifier';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_INVALID_PARAMETER_TYPE_FOR_FUNCTION =
    'europa.snowflake.SnowflakeTableExists.InvalidParameterTypeForFunction';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_MAX_FILE_SIZE_EXCEEDED =
    'europa.snowflake.SnowflakeTableExists.MaxFileSizeExceeded';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_MISSING_COLUMN =
    'europa.snowflake.SnowflakeTableExists.MissingColumn';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_NO_ACTIVE_WAREHOUSE_SELECTED =
    'europa.snowflake.SnowflakeTableExists.NoActiveWarehouseSelected';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_NOT_AUTHENTICATED_TO_SNOWFLAKE =
    'europa.snowflake.SnowflakeTableExists.NotAuthenticatedToSnowflake';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SnowflakeTableExists.NotExistsOrNotAuthorized';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_NOT_EXISTS_OR_OPERATION_CANNOT_BE_PERFORMED =
    'europa.snowflake.SnowflakeTableExists.NotExistsOrOperationCannotBePerformed';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_OBJECT_ALREADY_EXISTS =
    'europa.snowflake.SnowflakeTableExists.ObjectAlreadyExists';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_SCHEMA_NOT_EXISTS_OR_NOT_AUTHORIZED =
    'europa.snowflake.SnowflakeTableExists.SchemaNotExistsOrNotAuthorized';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_SNOWFLAKE_INTERNAL_SERVER_ERROR =
    'europa.snowflake.SnowflakeTableExists.SnowflakeInternalServerError';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_SNOWFLAKE_NOT_CONFIGURED =
    'europa.snowflake.SnowflakeTableExists.SnowflakeNotConfigured';
export const SNOWFLAKE_TABLE_EXISTS_SUCCESS_SNOWFLAKE_OBJECT_NOT_FOUND_OR_NOT_ACCESSIBLE =
    'europa.snowflake.SnowflakeTableExists.SnowflakeObjectNotFoundOrNotAccessible';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_SNOWFLAKE_QUERY_CANCELED =
    'europa.snowflake.SnowflakeTableExists.SnowflakeQueryCanceled';
export const SNOWFLAKE_TABLE_EXISTS_SUCCESS_TABLE_EXISTS =
    'europa.snowflake.SnowflakeTableExists.TableExists';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_TIMEOUT =
    'europa.snowflake.SnowflakeTableExists.Timeout';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_UNCATEGORIZED_SQL_ERROR =
    'europa.snowflake.SnowflakeTableExists.UncategorizedSqlError';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_UNEXPECTED_FAILURE =
    'europa.snowflake.SnowflakeTableExists.UnexpectedFailure';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_UNKNOWN_FUNCTION =
    'europa.snowflake.SnowflakeTableExists.UnknownFunction';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_UNKNOWN_FUNCTIONS =
    'europa.snowflake.SnowflakeTableExists.UnknownFunctions';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_USER_DIFFERS_FROM_TOKEN =
    'europa.snowflake.SnowflakeTableExists.UserDiffersFromToken';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_VALUE_NOT_RECOGNIZED =
    'europa.snowflake.SnowflakeTableExists.ValueNotRecognized';
export const SNOWFLAKE_TABLE_EXISTS_FAILURE_WAREHOUSE_SUSPENDED =
    'europa.snowflake.SnowflakeTableExists.WarehouseSuspended';
